import type {ReactElement} from 'react';
import {LineDashType} from '@PosterWhiteboard/items/line-item/line-item.types';

const DEFAULT_COLOR = '#403F5D';
const SELECTED_COLOR = '#00688C';

export const lineTypeNone = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="58" height="2" viewBox="0 0 58 2" fill="none">
    <path d="M0 1H58" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const lineTypeDash = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="57" height="3" viewBox="0 0 57 3" fill="none">
    <g clipPath="url(#clip0_3301_9835)">
      <path d="M-0.0333252 1.5H11.0833" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.95 1.5H26.0667" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M29.9333 1.5H41.05" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M44.9167 1.5H56.0334" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3301_9835">
        <rect width="58" height="3" fill="white" transform="translate(-1)" />
      </clipPath>
    </defs>
  </svg>
);
export const lineTypeLongDash = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="58" height="3" viewBox="0 0 58 3" fill="none">
    <g clipPath="url(#clip0_3301_9891)">
      <path d="M0.966675 1.5H17.0778" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.9444 1.5H37.0555" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M40.9223 1.5H57.0333" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3301_9891">
        <rect width="58" height="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const lineTypeDoted = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="58" height="3" viewBox="0 0 58 3" fill="none">
    <g clipPath="url(#clip0_3301_9960)">
      <path d="M0.966675 1.5H2.27858" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.17859 1.5H6.49049" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.39044 1.5H10.7024" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.6024 1.5H14.9143" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.8143 1.5H19.1262" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22.0262 1.5H23.3381" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M26.238 1.5H27.55" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M30.45 1.5H31.7619" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M34.662 1.5H35.9738" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M38.8737 1.5H40.1857" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M43.0857 1.5H44.3977" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M47.2977 1.5H48.6095" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M51.5096 1.5H52.8214" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M55.7214 1.5H57.0333" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3301_9960">
        <rect width="58" height="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const lineTypeDotDash = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="58" height="3" viewBox="0 0 58 3" fill="none">
    <g clipPath="url(#clip0_3301_10144)">
      <path d="M0.966675 1.5H8.45834" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.325 1.5H13.2917" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.1583 1.5H24.65" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M28.5167 1.5H29.4833" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M33.35 1.5H40.8416" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M44.7083 1.5H45.675" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M49.5417 1.5H57.0334" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3301_10144">
        <rect width="58" height="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const getSvgFromType = (type: LineDashType, isSelected?: boolean): ReactElement | undefined => {
  switch (type) {
    case LineDashType.NONE:
      return lineTypeNone(isSelected);
    case LineDashType.DASH:
      return lineTypeDash(isSelected);
    case LineDashType.LONG_DASH:
      return lineTypeLongDash(isSelected);
    case LineDashType.DOTED:
      return lineTypeDoted(isSelected);
    case LineDashType.DOT_DASH:
      return lineTypeDotDash(isSelected);
    default:
      return undefined;
  }
};

export const selectorLineTypeNone = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="2" viewBox="0 0 32 2" fill="none">
    <path d="M0 1H32" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const selectorLineTypeDash = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="2" viewBox="0 0 32 2" fill="none">
    <path d="M0 1H8" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 1H20" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M24 1H32" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const selectorLineTypeLongDash = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="2" viewBox="0 0 32 2" fill="none">
    <path d="M0 1H14" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 1H32" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const selectorLineTypeDoted = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="2" viewBox="0 0 32 2" fill="none">
    <path d="M0 1H2" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 1H7" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 1H12" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 1H17" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 1H22" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M25 1H27" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M30 1H32" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const selectorLineTypeDotDash = (isSelected?: boolean): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="2" viewBox="0 0 32 2" fill="none">
    <path d="M0 1H11.5" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.5 1H16.5" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20.5 1H32" stroke={isSelected ? SELECTED_COLOR : DEFAULT_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const getSelectorSvgsFromType = (type: LineDashType, isSelected?: boolean): ReactElement | undefined => {
  switch (type) {
    case LineDashType.NONE:
      return selectorLineTypeNone(isSelected);
    case LineDashType.DASH:
      return selectorLineTypeDash(isSelected);
    case LineDashType.LONG_DASH:
      return selectorLineTypeLongDash(isSelected);
    case LineDashType.DOTED:
      return selectorLineTypeDoted(isSelected);
    case LineDashType.DOT_DASH:
      return selectorLineTypeDotDash(isSelected);
    default:
      return undefined;
  }
};